export default __webpack_public_path__ + "static/media/imageseven.fb03fb5f.gif";